import React, { useState, useEffect } from "react";
import penIcon from "../../assets/images/DeathModuleNew/penWhite.svg";
import DEATH_API from "../../apis/death.api";
import moment from "moment";

export const ViewClientContacts = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingContent, setLoadingContent] = useState({
    title: "Loading contact details...",
    subtext: "Fetching the latest group and profile information.",
  });
  const [groups, setGroups] = useState(null);

  const getContactsGroup = async () => {
    try {
      setLoadingContent({
        title: "Loading contact details...",
        subtext: "Fetching the latest group and profile information.",
      });
      setLoading(true);
      setGroups(null);
      let apiResponse = await DEATH_API.getContactGroup(props && props.contact && props.contact.id);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        setGroups(apiResponse.groups);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    // Check if the URL contains the authorization code
    getContactsGroup();
  }, [(props.contact && props.contact.id)]);

  return (
    <div
      className="clientPlanDetailPanel clientPlanSectionShell"
    >
      <div
        className="clientPlanDetailContent"
      >
        <div className="clientPlanDetailHeader">
          <div className="clientPlanDetailCard">
            <div className="clientPlanDetailIdentity">
              {props && props.contact && props.contact.image ? (
                <div style={{ borderRadius: "50%" }}>
                  <img
                    src={props.contact.image}
                    height={"48px"}
                    width={"48px"}
                    alt={"new"}
                    style={{ borderRadius: "1rem" }}
                  />
                </div>
              ) : (
                <div className="clientPlanDetailAvatar">
                  {/* item.name.charAt(0).toUpperCase() */}
                  {props && props.contact && props.contact.name
                    ? props.contact.name
                        .split(" ")
                        .map((part) => part[0])
                        .join("")
                    : "N/A"}
                </div>
              )}
              <div className="clientPlanDetailMeta">
                <span className="clientPlanDetailName">
                  {props && props.contact && props.contact.name ? props.contact.name : "N/A"}
                </span>
                <span className="clientPlanDetailPhone">
                  {props && props.contact && props.contact.phoneNumber
                    ? props.contact.phoneNumber
                    : "N/A"}
                </span>
              </div>
            </div>
          </div>
          <div className="clientPlanDetailAction">
            <button
              className="clientPlanDetailEditButton"
              style={{
              }}
              onClick={() => {
                props.editContacts(true);
                props.viewContacts(false);
              }}
            >
              <img src={penIcon} alt="edit" />
            </button>
          </div>
        </div>
        <div className="clientPlanDetailInfo">
          <div>
            <div className="infocardrow" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.email && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Email</span>
                    <span
                      className="infocardsubTitle"
                      style={{ wordWrap: "break-word" }}
                    >
                      {props.contact.email ? props.contact.email : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {props && props.contact && props.contact.phoneNumber && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Phone Number </span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.phoneNumber
                        ? props.contact.phoneNumber
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && (props.contact.workStreet ||
                  props.contact.workCity ||
                  props.contact.workState) && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Address (Work)</span>
                    <span className="infocardsubTitle">
                      {props.contact.workStreet ? props.contact.workStreet : ""}
                    </span>
                    <span className="infocardsubTitle">
                      {props.contact.workCity ? props.contact.workCity : ""}
                    </span>
                    <span className="infocardsubTitle">
                      {props.contact.workState ? props.contact.workState : ""}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {groups && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Group</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {groups &&
                        groups.map((item, index) => (
                          <button
                            className="savebutton"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: "600",
                              padding: "10px 10px",
                              marginBottom: "4px",
                              // width: "90px",
                            }}
                            type="submit"
                          >
                            {item.groupName}
                          </button>
                        ))}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.jobCompany && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Job</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.jobCompany
                        ? props.contact.jobCompany
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {props && props.contact && props.contact.socialProfiles && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Social Profiles</span>
                    <span className="infocardsubTitle">
                      {props.contact.socialProfiles
                        ? props.contact.socialProfiles
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.workWebPage && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Webpage</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.workWebPage
                        ? props.contact.workWebPage
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className="infocardrowData">
                {props && props.contact && props.contact.birthday && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Birthday</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.birthday
                        ? moment(props.contact.birthday).format("MM-DD-YYYY")
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                {props && props.contact && props.contact.onAirDate && (
                  <React.Fragment>
                    <span className="infocardTitle1"> Other Date</span>
                    <span className="infocardsubTitle">
                      {" "}
                      {props.contact.onAirDate
                        ? moment(props.contact.onAirDate).format("MM-DD-YYYY")
                        : "N/A"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="clientPlanSectionLoadingOverlay">
          <div className="clientPlanSectionLoadingCard">
            <div className="clientPlanFormSpinner" />
            <div className="clientPlanFormLoadingText">{loadingContent.title}</div>
            <div className="clientPlanFormLoadingSubtext">{loadingContent.subtext}</div>
          </div>
        </div>
      )}
    </div>
  );
};
